import styles from './ErrorPanel.module.css';

interface ErrorPanelProps {
  /** Short headline, e.g. "Couldn't load your bookmarks". */
  title?: string;
  /** Human-readable cause, typically friendlyErrorMessage(error). */
  message: string;
  onRetry?: () => void;
  /** Optional ghost action beside Retry (e.g. "Reset connection"). */
  secondaryLabel?: string;
  onSecondary?: () => void;
  /** One compact line beside content it does not replace, e.g. rows kept
   *  on screen when reading more of them failed. */
  inline?: boolean;
}

/** Honest query-failure state: headline + cause + optional Retry / secondary. */
export function ErrorPanel({ title = 'That didn’t load', message, onRetry, secondaryLabel, onSecondary, inline }: ErrorPanelProps) {
  return (
    <div className={inline ? `${styles.panel} ${styles.inline}` : styles.panel} role="alert">
      <span className={styles.title}>{title}</span>
      <span className={styles.message}>{message}</span>
      {(onRetry || onSecondary) && (
        <div className={styles.actions}>
          {onRetry && (
            <button type="button" className={styles.retry} onClick={onRetry}>
              Retry
            </button>
          )}
          {onSecondary && secondaryLabel && (
            <button type="button" className={styles.secondary} onClick={onSecondary}>
              {secondaryLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
